import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AnimatedCard from "../../../components/AnimatedCard/AnimatedCard";
import { requestPasswordReset } from "../../../services/authApiService";
import { Button, Input, Alert } from "@repo/ui";
import { withTranslations } from "../../../hoc/withTranslations/withTranslations";
import * as Sentry from "@sentry/react";

const LOCALE = "modules_Registration_pages_PasswordRecovery";

const PasswordRecovery: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const [email, setEmail] = useState("");
  const [statusMessage, setStatusMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handlePasswordRecovery = async () => {
    setStatusMessage(null);
    setError(null);

    try {
      await requestPasswordReset(email); // Use the correct function
      setStatusMessage(t("password-recovery/success-message"));
    } catch (error) {
      Sentry.captureException(error);
      setError(t("password-recovery/error-message"));
    }
  };

  return (
    <div className="flex justify-center flex-col items-center min-h-[calc(100vh-6rem)] bg-background py-8">
      <AnimatedCard
        title={t("password-recovery/title")}
        className="bg-white max-w-lg w-full"
      >
        <div className="space-y-8">
          <p className="text-sm text-gray-700">
            {t("password-recovery/instruction")}
          </p>

          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-border w-full"
            placeholder={t("password-recovery/email-placeholder")}
          />
          <Button
            type="primary"
            onClick={handlePasswordRecovery}
            className="w-full"
          >
            {t("password-recovery/submit-button")}
          </Button>
          {statusMessage && <Alert message={statusMessage} level="success" />}
          {error && <Alert message={error} level="error" />}
        </div>
      </AnimatedCard>
    </div>
  );
};

export default withTranslations(LOCALE)(PasswordRecovery);
